import { render } from "./SpendPerItemCard.vue?vue&type=template&id=56b2301c"
import script from "./SpendPerItemCard.vue?vue&type=script&lang=js"
export * from "./SpendPerItemCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SpendPerItemCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56b2301c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56b2301c', __exports__)) {
    api.reload('56b2301c', __exports__)
  }
  
  module.hot.accept("./SpendPerItemCard.vue?vue&type=template&id=56b2301c", () => {
    api.rerender('56b2301c', render)
  })

}


export default __exports__